export default __webpack_public_path__ + "media/images/mailer/wordmark-f87ba50fbe2bb91a60c6b7e3d3201ca5.png";